<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">خدمات پیشرفته برای معامله‌گران بازارهای مالی</h3>
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">خدمات ما برای معامله‌گران بازارهای مالی</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در دنیای پرنوسان بازارهای مالی، معامله‌گران برای موفقیت نیازمند داده‌های دقیق، ابزارهای تحلیلی پیشرفته و استراتژی‌های معاملاتی هوشمندانه هستند. ما در شرکت خود با ارائه خدمات مبتنی بر هوش مصنوعی، تحلیل داده و فناوری‌های نوین، به معامله‌گران کمک می‌کنیم تا تصمیمات آگاهانه‌تری بگیرند، ریسک‌ها را کاهش دهند و بازدهی سرمایه‌گذاری خود را افزایش دهند.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">نیازهای معامله‌گران و چالش‌های موجود</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>نوسانات شدید بازار و ریسک‌های بالا</strong>
                                </li>
                                <li class="mt-3">
                                    <strong>نیاز به تحلیل داده‌های حجیم و تصمیم‌گیری سریع</strong>
                                </li>
                                <li class="mt-3">
                                    <strong>مدیریت سرمایه و بهینه‌سازی سبد دارایی‌ها</strong>
                                </li>
                                <li class="mt-3">
                                    <strong>استفاده از الگوریتم‌های معاملاتی و اتوماسیون</strong>
                                </li>
                                <li class="mt-3">
                                    <strong>دسترسی به داده‌های باکیفیت و پیش‌بینی روندهای بازار</strong>
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">راهکارهای ما برای معامله‌گران</h3>
                <h6>ما مجموعه‌ای از خدمات ویژه برای معامله‌گران ارائه می‌دهیم:</h6>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5"> تحلیل داده‌های بازار با هوش مصنوعی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>پردازش و تحلیل داده‌های تاریخی برای پیش‌بینی روندها</li>
                                <li>استفاده از مدل‌های یادگیری ماشین برای شناسایی فرصت‌های سرمایه‌گذاری</li>
                                <li>ارائه تحلیل‌های تکنیکال و فاندامنتال مبتنی بر داده‌های دقیق</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/transaction.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">توسعه و پیاده‌سازی الگوریتم‌های معاملاتی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>طراحی و توسعه ربات‌های معاملاتی خودکار</li>
                                <li>پیاده‌سازی استراتژی‌های معاملاتی مبتنی بر داده و الگوریتم‌های هوشمند</li>
                                <li>بهینه‌سازی الگوریتم‌های موجود برای افزایش دقت و سوددهی</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/transaction.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">مدیریت ریسک و بهینه‌سازی سبد دارایی‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل و مدیریت ریسک‌های سرمایه‌گذاری در بازارهای مالی</li>
                                <li>ایجاد مدل‌های بهینه‌سازی سبد سرمایه‌گذاری</li>
                                <li>ارائه ابزارهای مدیریت مالی و تخصیص بهینه دارایی‌ها</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/portfolio.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img20.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">ابزارهای پیشرفته تحلیل بازار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>داشبوردهای تحلیلی با داده‌های بلادرنگ</li>
                                <li>هشدارهای خودکار برای فرصت‌های خرید و فروش</li>
                                <li>تجزیه و تحلیل احساسات بازار از طریق پردازش زبان طبیعی (NLP)</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img20.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5"> بلاکچین و فناوری‌های غیرمتمرکز در معاملات مالی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>پیاده‌سازی راهکارهای دیفای (DeFi) برای معامله‌گران</li>
                                <li>استفاده از قراردادهای هوشمند برای معاملات امن و شفاف</li>
                                <li>بررسی و تحلیل داده‌های آنچین برای پیش‌بینی رفتار بازار</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img12.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">آموزش و مشاوره تخصصی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>دوره‌های آموزشی تحلیل تکنیکال و فاندامنتال</li>
                                <li>مشاوره اختصاصی برای بهینه‌سازی استراتژی‌های معاملاتی</li>
                                <li>ارائه وبینارها و کارگاه‌های تخصصی برای معامله‌گران حرفه‌ای</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img12.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">نتایج و ارزش‌آفرینی برای معامله‌گران</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/precision.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش دقت در پیش‌بینی روندهای بازار</strong> با تحلیل‌های مبتنی بر داده 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>کاهش ریسک و افزایش سودآوری </strong> با استفاده از الگوریتم‌های معاملاتی هوشمند
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/digital.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی سبد سرمایه‌گذاری </strong>و کاهش زیان‌های احتمالی 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/digital.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی سبد سرمایه‌گذاری </strong>و کاهش زیان‌های احتمالی 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img11.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش سرعت و دقت در اجرای معاملات </strong>با ربات‌های خودکار 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/analysis2.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>دسترسی به داده‌های دقیق و تحلیل‌های پیشرفته</strong> برای تصمیم‌گیری بهتر 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>چگونه می‌توانم از خدمات تحلیلی شما استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        شما می‌توانید از طریق پلتفرم ما به ابزارهای تحلیلی و داشبوردهای معاملاتی دسترسی داشته باشید و یا از مشاوره تخصصی ما بهره‌مند شوید.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>آیا خدمات شما برای معامله‌گران خرد هم مناسب است؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما راهکارهای متناسب با نیازهای معامله‌گران خرد و کلان را ارائه می‌دهیم تا همه کاربران بتوانند از خدمات ما بهره‌مند شوند.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>امنیت اطلاعات معاملاتی چگونه تضمین می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما از پروتکل‌های امنیتی پیشرفته، رمزنگاری داده‌ها و راهکارهای بلاکچین برای حفظ امنیت اطلاعات شما استفاده می‌کنیم.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>آیا امکان سفارشی‌سازی الگوریتم‌های معاملاتی وجود دارد؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما می‌توانیم الگوریتم‌های معاملاتی را بر اساس نیازهای خاص شما طراحی و پیاده‌سازی کنیم.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>آیا خدمات شما برای بازارهای خاصی محدود است؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        خیر، ما راهکارهایی برای تمامی بازارهای مالی از جمله سهام، فارکس، ارزهای دیجیتال و کالاهای اساسی ارائه می‌دهیم.
                        <br>
                        ما به عنوان یک شرکت دانش‌بنیان، به معامله‌گران کمک می‌کنیم تا با استفاده از فناوری‌های نوین، معاملات خود را بهینه‌سازی کرده و در بازارهای مالی موفق‌تر باشند. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>